import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import EcosystemSection from '../components/EcosystemSection/EcosystemSection';
import PromoSection from '../components/PromoSection/PromoSection';
import CTASection from '../components/CTASection/CTASection';
import Footer from '../components/Footer/Footer';
import SupportWidget from '../components/SupportWidget/SupportWidget';
import ConnectWalletModal from '../components/ConnectWallet/ConnectWalletModal';
import { WalletModalProvider } from '../context/WalletModalContext';

export default function LandingPage() {
  return (
    <WalletModalProvider>
      <div className="app">
        <Header />
        <main>
          <Hero />
          <EcosystemSection />
          <PromoSection />
          <CTASection />
        </main>
        <Footer />
        <SupportWidget />
        <ConnectWalletModal />
      </div>
    </WalletModalProvider>
  );
}